import AgTechViewDialog from '@agtech/web/components/Portals/Dialogs/AgTechViewDialog';
import React from 'react'
import { AgTechButton, AgTechButtonProps, AgTechClickEventHandler } from '@agtech/web/components/Buttons/AgTechButtons';
import AgTechViewDialogTabPage from '@agtech/web/components/Pages/Tabbed/Flavors/AgTechViewDialogTabPage';
import { getSaleContactDetailTabPageProps } from '../pages/SaleContactDetailsTabPage';
import {  useSaleContactDataGetContactDetailsQuery } from '@sales/data/operation/contacts/SaleContactDataQueries';
import { getContactFullName } from '@agtech/data/contacts/ContactData';
import ContactDialog from '@agtech/web/integrations/contacts/dialogs/ContactDialog';

export type SaleContactDetailDialogProps = { 
    contactId: number
}

const SaleContactDetailDialog = (props: SaleContactDetailDialogProps) => {
    const dialogQuery = useSaleContactDataGetContactDetailsQuery(props.contactId);

    return (
        <AgTechViewDialog
            data={{
                query: dialogQuery
            }}
            structure={{
                width: '800px',
                body: {
                    classes: 'p-0'
                }
            }}
        >
            {(contactDetails) => {
                return (
                    <AgTechViewDialogTabPage
                        {...getSaleContactDetailTabPageProps({ contactDetails })}
                        header={{
                            header: getContactFullName(contactDetails.contact),
                            detail: contactDetails.contact.ranchName,
                            settings: {
                                content: {
                                    body: () => (
                                        <ContactDialog.Button
                                            contactId={contactDetails.contact.id}
                                            classes='mr-[56px] mt-[8px] button-highlight'
                                        />
                                    )
                                },
                                badge: {
                                    icon: 'fas fa-user-circle',
                                    classes: 'text-secondary'
                                }
                            }
                        }}
                    />
                )
            }}
        </AgTechViewDialog>
    )
}

SaleContactDetailDialog.Open = (e: AgTechClickEventHandler, props: SaleContactDetailDialogProps) => e.dialogs.openDialog({
    dialog: () => <SaleContactDetailDialog contactId={props.contactId} />
});

SaleContactDetailDialog.Button = (props: SaleContactDetailDialogProps & AgTechButtonProps) => {
    return (
        <AgTechButton
            text={'View Contact'}
            icon='fas fa-eye'
            {...props}
            action={e => SaleContactDetailDialog.Open(e, props)}
        />
    )
}

export default SaleContactDetailDialog